export class ScheduleJob {
    dueTime: string;
    id: string;
    scheduledBy: string;
    status: string;
}
